import { gql } from '@apollo/client'

export default gql`
  fragment fullObjectiveFragment on ObjectiveDTO {
    id
    globalId
    title
    due
    start
    status
    targetAmount
    achievedAmount
    currency
    attachment
    closedDate
    globalId
    keyResults {
      id
      text
      completed
      globalId
    }
    taskNotes
    noteList {
      id
      text
      date
      globalId
      author {
        id
        firstName
        lastName
      }
    }
    attachmentDownloadToken
    appraisalSeason {
      id
      companyId
      country
      year
      fromDate
      toDate
    }
  }
`
